<template>
  <el-button type="primary" @click="handRedImport()" size="mini" plain>查询发票</el-button>

  <el-dialog v-model="dialogFormVisible" width="30%" title="手工填写红字信息">
    <el-form size="mini" label-position="right" label-width="100px">
      <!-- <el-form-item label="红字信息表信息">
        <el-input v-model="listQuery.hzxxbxx"></el-input>
      </el-form-item> -->
      <el-form-item label="发票代码">
        <el-input v-model="listQuery.fpdm"></el-input>
      </el-form-item>
       <el-form-item label="发票号码">
        <el-input v-model="listQuery.fphm"></el-input>
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button size="mini" type="primary" @click="handConfirm()">确定 </el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>
import { redInfo } from "@/api/apply";
export default {
  name: 'redHandFsComponent',
  data() {
    return {
      dialogFormVisible: false,
      listQuery: {
        type: "3",
        comId: this.$store.getters['user/comInfo'].id*1,
      },
    }
  },
  created () {
    
  },
  methods: {
    handRedImport(){
      this.dialogFormVisible = true
    },
    handConfirm(){
      redInfo(this.listQuery).then(res=>{
        if(res.data.msg == "success"){
          this.$emit('success', res.data.data.info)
          this.dialogFormVisible = false
        }
      })
    },
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

</style>
